import { rem } from 'polished'
import { css } from 'styled-components'

export const MOBILE_TIMELINE_INSET = 16
export const MOBILE_STOP_IMAGE_SIZE = 56
/** Small chip metrics — 28px tall (6 + 16 + 6), matching `FILTER_CHIP_HEIGHTS.small`. */
export const MOBILE_DAY_PILL_FONT_SIZE = 12
export const MOBILE_DAY_PILL_LINE_HEIGHT = 16
export const MOBILE_DAY_PILL_BLOCK_PADDING = 6
export const MOBILE_DAY_PILL_INLINE_PADDING = 8
export const MOBILE_DAY_PILL_MIN_WIDTH = 72

/**
 * Timeline canvas overrides for the mobile surface.
 *
 * Mobile drops the desktop card-in-a-canvas treatment: stop and transport sections stretch
 * edge to edge with no border or radius, and carry the view's single {@link MOBILE_TIMELINE_INSET}
 * inset themselves — the canvas content and the nested itinerary sheet contribute none. The
 * canvas keeps its light background so the gaps between the full-bleed white sections still
 * read as separations.
 */
export const mobileTimelineCanvasVars = css`
  --trip-plan-canvas-padding: ${rem(MOBILE_TIMELINE_INSET)};
  --trip-plan-canvas-narrow-padding: ${rem(MOBILE_TIMELINE_INSET)};
  --trip-plan-canvas-content-padding: 0;
  --trip-plan-canvas-section-padding: ${rem(MOBILE_TIMELINE_INSET)};
  --trip-plan-canvas-nested-padding: 0;
  --trip-plan-canvas-section-border-width: 0;
  --trip-plan-canvas-section-radius: 0;
  --trip-plan-canvas-stop-image-size: ${rem(MOBILE_STOP_IMAGE_SIZE)};
  --trip-plan-canvas-day-pill-font-size: ${MOBILE_DAY_PILL_FONT_SIZE}px;
  --trip-plan-canvas-day-pill-line-height: ${MOBILE_DAY_PILL_LINE_HEIGHT}px;
  --trip-plan-canvas-day-pill-padding: ${rem(MOBILE_DAY_PILL_BLOCK_PADDING)} ${rem(MOBILE_DAY_PILL_INLINE_PADDING)};
  --trip-plan-canvas-day-pill-min-width: ${rem(MOBILE_DAY_PILL_MIN_WIDTH)};
`
